import { NotificationListFiltersDto } from '@dto/notification-list/notification-list-filters.dto';
import { NotificationListDto } from '@dto/notification-list/notification-list.dto';
import { createAction, props } from '@ngrx/store';
import { NotificationPage } from '@type/notifications.type';

const state = '[Notification List]';

export const initAllNotificationPage = createAction(
  `${state}[Init all Notifications pages]`,
);

export const loadNotificationPage = createAction(
  `${state}[Load Notification Page] Load notifications`,
  props<{
    notificationPage: NotificationPage;
    currentPageNumber: number;
    filters: NotificationListFiltersDto;
    pageSize: number;
    reload: boolean;
  }>()
);

export const loadNotificationPageSuccess = createAction(
  `${state}[Load Notification Page] Load notifications Success`,
  props<{
    notificationPage: NotificationPage;
    notificationList: NotificationListDto;
    reload: boolean;
  }>()
);

export const loadNotificationPageFailure = createAction(
  `${state}[Load Notification Page] Load notifications Failure`,
  props<{ notificationPage: NotificationPage; error: string }>()
);
